import { render, staticRenderFns } from "./addTraining.vue?vue&type=template&id=0a658dd1&scoped=true&"
import script from "./addTraining.vue?vue&type=script&lang=js&"
export * from "./addTraining.vue?vue&type=script&lang=js&"
import style0 from "./addTraining.vue?vue&type=style&index=0&id=0a658dd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a658dd1",
  null
  
)

export default component.exports